import fileDownload from 'js-file-download'

import axiosAuth from './axiosAuth'

export const downloadDbDump = () =>
    axiosAuth
        .get('/db/dump/data', {
            responseType: 'blob',
        })
        .then((response) => {
            fileDownload(response.data, 'db_dump.tgz')
        })

export const downloadLogs = () =>
    axiosAuth
        .get('/db/dump/logs', {
            responseType: 'blob',
        })
        .then((response) => {
            fileDownload(response.data, 'logs_dump.tgz')
        })

export const uploadDbDump = (file: FormData) => {
    axiosAuth.post(`/db/restore/data`, file, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}

export const uploadLogs = (file: FormData) =>
    axiosAuth.post(`/db/restore/logs`, file, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
